import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/globalStyles/index.scss';
import i18n from 'i18n';
import { syncDocumentLanguage } from 'i18n/changeLanguage';
import App from 'App';

syncDocumentLanguage(i18n.language);

ReactDOM.render(<App />, document.getElementById('root'));
